// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
}

.form-inputs {
  display: flex;
  align-items: center;
}

.form-inputs .form-control {
  height: 40px;
  min-width: 350px;
}

.form-inputs .form-control:focus {
  box-shadow: none;
  border: 1px solid #000;
}

.search-icon {
  margin-left: 5px;
  background-color: #333742;
  padding: 10px 13px;
  color: rgb(210, 207, 207);
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.search-icon:hover {
  color: #fff;
  background-color: #3B71CA;
  transition: all 0.3s ease-in-out;
}

.modal-header {
  border-bottom: none;
}

.modal-title {
  color: #333742;
  font-weight: 600;
}

.btn-success {
  min-width: 110px;
}

.btn-dark {
  min-width: 100px;
}

.inner {
  width: 100%;
}

.no-data {
  padding: 40px 20px;
  text-align: center;
}
.no-data i {
  font-size: 55px;
  color: #808080;
}
.no-data p {
  margin-top: 15px;
  font-size: 18px;
  color: #666;
}

/* Pagination Alignment */
app-pagination {
  display: inline-block;
}

/* Optional: Improve Dialog Scrolling */
:host ::ng-deep .mat-dialog-container {
  overflow: hidden;
}

/* Optional: Main Table Styling */
:host ::ng-deep app-main-table {
  display: block;
  min-height: 350px;
}

/* Responsive */
@media (max-width: 768px) {
  .form-control {
    min-width: 100%;
  }
  .form-inputs {
    flex-direction: column;
    align-items: stretch;
  }
  .search-icon {
    margin-left: 0;
    margin-top: 10px;
  }
  .modal-header {
    flex-direction: column;
    align-items: flex-start;
  }
  .btn-success {
    margin-top: 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/features/secure-blockchain/authoring-tools/smart-contract-access-flow/missing-access-flow-dialog/missing-access-flow-dialog.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;AACJ;;AAEA;EACI,aAAA;EACA,mBAAA;AACJ;;AAEA;EACI,YAAA;EACA,gBAAA;AACJ;;AAEA;EACI,gBAAA;EACA,sBAAA;AACJ;;AAEA;EACI,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACJ;AACI;EACI,WAAA;EACA,yBAAA;EACA,gCAAA;AACR;;AAGA;EACI,mBAAA;AAAJ;;AAGA;EACI,cAAA;EACA,gBAAA;AAAJ;;AAGA;EACI,gBAAA;AAAJ;;AAGA;EACI,gBAAA;AAAJ;;AAGA;EACI,WAAA;AAAJ;;AAGA;EACI,kBAAA;EACA,kBAAA;AAAJ;AAEI;EACI,eAAA;EACA,cAAA;AAAR;AAGI;EACI,gBAAA;EACA,eAAA;EACA,WAAA;AADR;;AAKA,yBAAA;AACA;EACI,qBAAA;AAFJ;;AAKA,uCAAA;AACA;EACI,gBAAA;AAFJ;;AAKA,iCAAA;AACA;EACI,cAAA;EACA,iBAAA;AAFJ;;AAKA,eAAA;AACA;EAEI;IACI,eAAA;EAHN;EAME;IACI,sBAAA;IACA,oBAAA;EAJN;EAOE;IACI,cAAA;IACA,gBAAA;EALN;EAQE;IACI,sBAAA;IACA,uBAAA;EANN;EASE;IACI,gBAAA;EAPN;AACF","sourcesContent":[":host {\n    display: block;\n}\n\n.form-inputs {\n    display: flex;\n    align-items: center;\n}\n\n.form-inputs .form-control {\n    height: 40px;\n    min-width: 350px;\n}\n\n.form-inputs .form-control:focus {\n    box-shadow: none;\n    border: 1px solid #000;\n}\n\n.search-icon {\n    margin-left: 5px;\n    background-color: #333742;\n    padding: 10px 13px;\n    color: rgb(210, 207, 207);\n    border-radius: 4px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    &:hover {\n        color: #fff;\n        background-color: #3B71CA;\n        transition: all 0.3s ease-in-out;\n    }\n}\n\n.modal-header {\n    border-bottom: none;\n}\n\n.modal-title {\n    color: #333742;\n    font-weight: 600;\n}\n\n.btn-success {\n    min-width: 110px;\n}\n\n.btn-dark {\n    min-width: 100px;\n}\n\n.inner {\n    width: 100%;\n}\n\n.no-data {\n    padding: 40px 20px;\n    text-align: center;\n\n    i {\n        font-size: 55px;\n        color: #808080;\n    }\n\n    p {\n        margin-top: 15px;\n        font-size: 18px;\n        color: #666;\n    }\n}\n\n/* Pagination Alignment */\napp-pagination {\n    display: inline-block;\n}\n\n/* Optional: Improve Dialog Scrolling */\n:host ::ng-deep .mat-dialog-container {\n    overflow: hidden;\n}\n\n/* Optional: Main Table Styling */\n:host ::ng-deep app-main-table {\n    display: block;\n    min-height: 350px;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n\n    .form-control {\n        min-width: 100%;\n    }\n\n    .form-inputs {\n        flex-direction: column;\n        align-items: stretch;\n    }\n\n    .search-icon {\n        margin-left: 0;\n        margin-top: 10px;\n    }\n\n    .modal-header {\n        flex-direction: column;\n        align-items: flex-start;\n    }\n\n    .btn-success {\n        margin-top: 10px;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
